import { render } from "./OldPagination.vue?vue&type=template&id=5d3f1910&scoped=true"
import script from "./OldPagination.vue?vue&type=script&lang=js"
export * from "./OldPagination.vue?vue&type=script&lang=js"

import "./OldPagination.vue?vue&type=style&index=0&id=5d3f1910&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d3f1910"]])

export default __exports__